import PropTypes from 'prop-types'
import classnames from 'classnames'

const renderHeader = (header) => {
  if (header) {
    return (
      <div className="card-header">
        {header}
      </div>
    )
  } else
    return null
}

const getClasses = ({ panelType, className }) => {
  const type = panelType || 'default'
  const buttonClass = className || ''
  return classnames('card', 'card-' + type, buttonClass)
}

export const Panel = ({
  header,
  className,
  panelType,
  onClick,
  children
}) => {
  const classes = getClasses({ panelType, className })

  return (
    <div
      className={classes}
      onClick={onClick}
    >
      {renderHeader(header)}
      <div className="card-body">
        {children}
      </div>
    </div>
  )
}

Panel.propTypes = {
  header: PropTypes.node,
  className: PropTypes.string,
  panelType: PropTypes.string,
  onClick: PropTypes.func
}
